"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconPallet = function SvgIconPallet(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "pallet icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Pallet Icon'), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "nonzero",
    d: "M34.62 5.375h5.838C42.411 5.375 44 6.938 44 8.858c0 1.923-1.589 3.486-3.542 3.486h-1.992v21.301h3.735v1.726h-4.2c-2.191 0-3.597 2.331-3.616 4.553H15.018c-.415 1.808-1.324 2.687-2.761 2.7-1.441.018-2.354-.855-2.8-2.7-1.264 0-2.537-.006-3.808 0-1.12.006-1.638-.484-1.646-1.582-.002-.338-.006-.675 0-1.013.016-.88.561-1.43 1.45-1.434 2.007-.008 4.011-.006 6.019-.006 5.957 0 19.452.01 19.452.01l1.589-7.307h4.24V12.344H34.62c-1.95 0-3.54-1.563-3.54-3.486 0-1.92 1.59-3.483 3.54-3.483zm4.07 30.865h.052c1.646.025 3.006 1.392 2.994 3.01-.01 1.635-1.393 2.992-3.05 2.984-1.662-.001-3.057-1.376-3.041-2.992.013-1.665 1.381-3.002 3.045-3.002z"
  }));
};

var _default = SvgIconPallet;
exports.default = _default;